<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('institution') }}</div>
      <div>
        <button
          class="btn-blue"
          @click.prevent.stop="onEditInstitute(instituteDetails.institution_id)"
        >{{ $t('edit') }}</button>
        <router-link class="btn-blue" to="institution">{{ $t('institution') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('institution') }} {{ $tc('name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="instituteDetails.institution_name"
              class="mr-3"
            >{{instituteDetails.institution_name}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema',1) }} {{ $tc('name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.Cinema" class="mr-3">{{selected.Cinema}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('institution') }} {{ $tc('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="instituteDetails.institution_is_active=='Y'" class="mr-3">{{$t('yes')}}</span>
            <span v-else class="mr-3">{{$t('no')}}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="instituteDetails.created_at"
              class="mr-3"
            >{{instituteDetails.created_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="instituteDetails.created_by" class="mr-3">{{instituteDetails.created_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="instituteDetails.updated_at"
              class="mr-3"
            >{{instituteDetails.updated_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="instituteDetails.updated_by" class="mr-3">{{instituteDetails.updated_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div v-for="(item,index) in items" :key="index" class="col-md-12 py-2">
            <div class="row border-bottom" v-if="item.fieldname == 'created_at'">
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ }}</div>
            </div>
            <div class="row border-bottom" v-else-if="item.fieldname == 'updated_at'">
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
            </div>
            <div class="row border-bottom" v-else-if="item.fieldname !== 'g_id'">
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";

const selected = {
  Cinema: "",
};

export default {
  data() {
    return {
      roleID: "",
      institution_id: "",
      Cinemas: [],
      CinemasMethod: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      selected: selected,
      items: [],
      instituteDetails: [],
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;

    const { institution_id } = this.$route.query;

    // this.getCountriesList();

    if (institution_id) {
      this.getInstituteDetails(institution_id);
    } else {
      const { institution_id } = this.$route.query;
      this.institution_id = this.$route.query.user_id;

      if (institution_id) {
        this.getInstituteDetails(institution_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
    getInstituteDetails: function (institution_id) {
      MarketingService.getInstitutionDetails({ institution_id }).then(
        (response) => {
          const { data } = response;
          if (data.Records) {
            this.instituteDetails = {
              ...this.instituteDetails,
              ...data.Records[0],
            };

            this.getViewUsersDetails(
              data.Records[0].created_by,
              "instituteDetails",
              "created_by"
            );

            this.getViewUsersDetails(
              data.Records[0].updated_by,
              "instituteDetails",
              "updated_by"
            );
            // console.log("instituteDetails :", this.instituteDetails);
            this.getCinemasList(this.instituteDetails.cinema_id || null);
          }
        }
      );
    },
    getViewUsersDetails(user_id, mainkey, subkey) {
      this[mainkey][subkey] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[mainkey][subkey] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
    onEditInstitute: function (institution_id) {
      this.$router.push({
        path: "/marketing/edit-institution",
        query: { institution_id: institution_id },
      });
      // console.log("bank_id :", bank.bank_id);
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      let body = this.getRequestBody("GET", undefined, this.CinemasMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            if (cine_id) {
              this.Cinemas.map((x) => {
                if (cine_id === x.cine_id) {
                  this.selected.Cinema = x.cine_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/InstitutionComponents/viewInstitution.vue